import { Injectable } from '@angular/core';
import {
    HttpRequest
    ,HttpHandler
    ,HttpEvent
    ,HttpInterceptor
    ,HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgbModal} from "@ng-bootstrap/ng-bootstrap";

import { FvmsApiAuthService } from "./fvms.api.auth.service";

@Injectable({providedIn: 'root'})
export class FvmsApiHttpInterceptor implements HttpInterceptor {
    currentUserInfo:any;

    constructor(
        public fvmsApiAuthService: FvmsApiAuthService
        ,private modalService: NgbModal
    ) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        request = request.clone({
            setParams:{
                "runtime": new Date().getTime().toString()
            }
        });

        if(this.currentUserInfo){
            if(this.currentUserInfo.token){
                
                request = request.clone({
                    setHeaders: {
                        "x-access-token": this.currentUserInfo.token
                    }
                });
            }
        }
        return next.handle(request)
            .pipe(map((event:HttpEvent<any>) => {
                if(event instanceof HttpResponse){
                    // console.log(event);
                    switch(event.body.resultStatus) {
                        case "auth": { 
                            console.log(event.body.resultMessage);
                            this.modalService.dismissAll();
                            this.fvmsApiAuthService.signOut();
                            break;
                        }
                        case "error": {
                            console.error("interceptor",event.body.resultMessage);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
                return event;
        }));
    }
}
